import { useTranslation } from 'next-i18next';

import { confirmDialog } from '@/ui_v3';

export const useConfirmImageReplace = () => {
  const { t } = useTranslation(['build', 'common']);

  const confirm = async () => {
    const shouldReplaceImage = await confirmDialog.openAsync({
      header: {
        title: t('build.imageUpload.confirmReplace'),
      },
      confirmText: t('common:change'),
    });

    return shouldReplaceImage;
  };

  return {
    confirm,
  };
};
